// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3746":"567d5be95c9ad14a","5859":"404a68cc91d426bb","8733":"6af91a9450047a08"}[chunkId] + ".css";
};